<template>
  <VForm @submit.prevent="save">
    <VRow no-gutters>
      <VCol cols="12">
        <VTextField
          id="firstName"
          v-model="firstName"
          class="mb-3"
          :label="$t('firstName')+' *'"
          outlined
          dense
          autocomplete="given-name"
          :error-messages="errors.firstName"
          @input="errors.firstName = null"
        />
        <VTextField
          id="lastName"
          v-model="lastName"
          class="mb-3"
          :label="$t('lastName')+' *'"
          outlined
          dense
          autocomplete="family-name"
          :error-messages="errors.lastName"
          @input="errors.lastName = null"
        />
        <VTextField
          id="email"
          v-model="email"
          class="mb-3"
          :label="$t('email')+' *'"
          outlined
          dense
          readonly
          disabled
          autocomplete="email"
        />
        <PhoneNumberInput
          :key="phone"
          v-model="phone"
          required
          :error-messages="errors.phone"
          @input="errors.phone = null"
        />
      </VCol>
    </VRow>
    <VRow justify="center" no-gutters>
      <VCol
        v-if="hasErrorMessageOnly"
        cols="12"
        md="6"
        class="red--text text-center mb-6"
      >
        {{ errorMessage }}
      </VCol>
      <VCol cols="12" class="text-center">
        <VBtn
          color="success"
          dark
          elevation="0"
          type="submit"
          :loading="loading"
        >
          {{ $t('save') }}
        </VBtn>
      </VCol>
    </VRow>
  </VForm>
</template>

<script>
import useUser from '@/compositions/useUser';
import { ref, watch } from '@vue/composition-api';
import ValidationMixin from '../mixins/ValidationMixin';
import PhoneNumberInput from '../components/Input/PhoneNumberInput.vue';
import { normalizePhoneNumber } from '../functions';
import User from '../orm/models/User/User';

export default {
  name: 'UserInfo',
  components: {
    PhoneNumberInput,
  },
  mixins: [ValidationMixin],
  setup() {
    const { currentUser } = useUser();

    const firstName = ref(currentUser.value.firstName);
    const lastName = ref(currentUser.value.lastName);
    const email = ref(currentUser.value.email);
    const phone = ref(currentUser.value.phone);

    watch(currentUser, () => {
      firstName.value = currentUser.value.firstName;
      lastName.value = currentUser.value.lastName;
      email.value = currentUser.value.email;
      phone.value = currentUser.value.phone;
    });

    return {
      user: currentUser,
      firstName,
      lastName,
      email,
      phone,
    };
  },
  methods: {
    async save() {
      await this.withValidationHandling(async () => {
        await User.api().update({
          firstName: this.firstName,
          lastName: this.lastName,
          phone: normalizePhoneNumber(this.phone),
        });
        this.$toast(this.$t('dataSaved'));
      });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  firstName: First name
  lastName: Last name
  email: E-mail
  save: Save
  dataSaved: Data saved
</i18n>

<i18n locale="ru" lang="yaml">
  firstName: Имя
  lastName: Фамилия
  email: E-mail
  save: Сохранить
  dataSaved: Данные изменены
</i18n>
